import React, { useEffect } from 'react'
import Dialog from '../ModalDialog'
import DialogContentText from '@mui/material/DialogContentText'
import PropTypes from 'prop-types'
export default function Deprogram({
  open,
  handleClose,
  handleDissocierCourseClick,
  codeCourse,
  payload,
  isLoadingActionOrder,
  errorActionCourse,
}) {
  const dissocierCourse = () => {
    handleDissocierCourseClick(codeCourse, payload)
  }

  useEffect(() => {
    if (errorActionCourse) handleClose()
  }, [errorActionCourse])

  return (
    <Dialog
      maxWidthDialog={'sm'}
      open={open}
      title={'Dissociation'}
      content={
        <DialogContentText sx={{ pr: 2, pb: 2 }}>
          {
            'Cette action est définitive et ne peut pas être annulée,  Voulez-vous confirmer la dissociation ?'
          }
        </DialogContentText>
      }
      handleClose={handleClose}
      handleClickAction={dissocierCourse}
      isLoadingButtonAction={isLoadingActionOrder}
    />
  )
}
Deprogram.propTypes = {
  open: PropTypes.bool,
  handleClose: PropTypes.func,
  handleDissocierCourseClick: PropTypes.func,
  codeCourse: PropTypes.string,
  payload: PropTypes.object,
  isLoadingActionOrder: PropTypes.bool,
  errorActionCourse: PropTypes.string,
}
